import type { RawKey } from './zh-CN';

/** 巴西葡语。**这是这个产品的主要市场**（币种 BRL，原版客户端也是 pt-BR）。 */
export const ptBR: Record<RawKey, string> = {
  'tab.lobby': 'Início',
  'tab.activity': 'Promoções',
  'tab.agent': 'Agente',
  'tab.deposit': 'Depositar',
  'tab.profile': 'Perfil',

  'action.loginOrRegister': 'Entrar',
  'action.login': 'Entrar',
  'action.register': 'Cadastrar',
  'action.close': 'Fechar',
  'action.settings': 'Configurações',
  'action.myAccount': 'Minha conta',
  'action.working': 'Aguarde…',
  'action.view': 'Ver',
  'action.retry': 'Tentar de novo',

  'lobby.hot': 'Em alta',
  'lobby.more': 'Mais',
  'lobby.less': 'Menos',
  'lobby.providers': 'Provedores de jogos',
  'lobby.allProviders': 'Todos',
  'lobby.otherProvider': 'Outros',
  'lobby.title': 'Início',
  'lobby.count_one': '{n} jogo',
  'lobby.count_other': '{n} jogos',
  'lobby.none': 'Nenhum jogo disponível no momento',
  'lobby.maintenance': 'Em manutenção',
  'lobby.unavailable': 'Temporariamente indisponível',
  'lobby.laterNote': 'Categorias, jogados recentemente e filtros por provedor virão em breve.',
  'lobby.search': 'Buscar jogos',
  'lobby.noMatch': 'Nenhum jogo encontrado para “{q}”',
  'lobby.liveTables': 'Mesas ao vivo',
  'lobby.tableClosed': 'Mesa fechada',
  'lobby.liveUnavailable': 'Dados ao vivo indisponíveis',
  'lobby.dealer': 'Crupiê',
  'lobby.betLimits': 'Limites de aposta',
  'lobby.players': 'Jogadores',
  'lobby.seats': 'Lugares livres',
  'lobby.recentResults': 'Resultados recentes',
  'lobby.shoe': 'Banca / Jogador / Empate',
  'lobby.newTable': 'Mesa nova',

  'game.tag_one': '{provider} · {grid} · {n} linha',
  'game.tag_other': '{provider} · {grid} · {n} linhas',
  'game.tagGrid': '{provider} · {grid}',
  'game.tagLines_one': '{provider} · {n} linha',
  'game.tagLines_other': '{provider} · {n} linhas',

  'placeholder.activity': 'Promoções, missões, check-in diário, rankings — ainda não implementado',
  'placeholder.agent': 'Links de indicação, rede, comissões — ainda não implementado',
  'placeholder.deposit': 'Depósitos e saques dependem do sistema financeiro',
  'placeholder.profile': 'Perfil, histórico de apostas, segurança — por enquanto em Configurações',

  'auth.phone': 'Celular',
  'auth.phoneHint': 'Selecione o país e digite seu número. Exemplo: {example}',
  'auth.countryLoading': 'Carregando códigos de país…',
  'auth.countryLoadFailed': 'Não foi possível carregar os países. Tente novamente.',
  'auth.registrationClosed': 'Cadastro temporariamente fechado. Contas existentes podem entrar.',
  'err.REGISTRATION_COUNTRY_DISABLED': 'Cadastro indisponível para este país. Escolha um país habilitado.',
  'auth.countryCode': 'Código do país',
  'auth.country.PH': 'Filipinas',
  'auth.country.BR': 'Brasil',
  'auth.password': 'Senha',
  'auth.passwordHint': 'Mínimo de 8 caracteres',
  'auth.toRegister': 'Ainda não tem conta? Cadastre-se',
  'auth.toLogin': 'Já tem conta? Entrar',
  'auth.noSmsYet': 'A verificação por SMS ainda não existe — você não receberá código.',

  'err.BAD_CREDENTIALS': 'Celular ou senha incorretos',
  'err.IDENTIFIER_TAKEN': 'Este celular já está cadastrado',
  'err.WEAK_PASSWORD': 'A senha precisa ter ao menos 8 caracteres',
  'err.ACCOUNT_LOCKED': 'Muitas tentativas. Tente novamente mais tarde',
  'err.ACCOUNT_DISABLED': 'Esta conta está bloqueada',
  'err.NO_SESSION': 'Sua sessão expirou. Entre novamente',
  'err.BAD_PHONE': 'Número inválido — confira o país selecionado e o número',
  'history.status.open': 'Em andamento',
  'history.status.aborted': 'Aguardando liquidação',
  'history.status.settled': 'Liquidada',
  'history.status.canceled': 'Cancelada',
  'history.title': 'Histórico de apostas',
  'history.empty': 'Nenhuma rodada ainda',
  'history.free': 'Rodada grátis',
  'history.reward': 'Prêmio',
  'history.adjustment': 'Ajuste',
  'history.more': 'Carregar mais',

  'err.GAME_UNAVAILABLE': 'Este jogo está indisponível no momento. Tente mais tarde',
  'err.NETWORK': 'Não foi possível conectar ao servidor',
  'err.UNKNOWN': 'Algo deu errado. Tente novamente mais tarde',

  'profile.balance': 'Saldo',
  'profile.vip': 'Nível VIP',
  'profile.wager': 'Rollover',
  'profile.wagerNone': 'Sem exigência de rollover no momento',
  'profile.wagerDone': 'Cumprido',
  'profile.rounds': 'Rodadas jogadas',
  'profile.noNickname': 'Sem apelido ainda',
  'profile.editNickname': 'Alterar apelido',
  'profile.nickname': 'Apelido',
  'profile.nicknameHint': '1 a 24 caracteres',
  'profile.nicknameNotUnique': 'Apelidos podem se repetir — sua conta é sempre identificada pelo seu ID.',
  'profile.renamesLeft_one': 'Resta {n} troca de apelido',
  'profile.renamesLeft_other': 'Restam {n} trocas de apelido',
  'profile.renamesNone': 'Sem trocas de apelido restantes',
  'profile.idLabel': 'ID {v}',
  'profile.copyId': 'Copiar ID',
  'profile.idCopied': 'Copiado',
  'profile.copyFailed': 'Não foi possível copiar — toque e segure o ID para copiar',
  'err.NICKNAME_RENAME_LIMIT': 'Você já usou todas as trocas de apelido',
  'err.BAD_NICKNAME': 'Esse apelido não é permitido',
  'err.NICKNAME_CHARS': 'O apelido tem caracteres invisíveis — provavelmente de copiar e colar. Digite manualmente.',
  'action.save': 'Salvar',
  'profile.changeAvatar': 'Trocar avatar',
  'profile.uploadOwn': 'Enviar a sua',
  'profile.uploadHint': 'JPG / PNG / WebP, até 512 KB',
  'profile.yourUpload': 'Sua imagem',
  'profile.deposited': '{v} depositados',
  'profile.maxLevel': 'Nível máximo atingido',
  'profile.toNextLevel': 'Deposite mais {v} para chegar ao VIP {n}',
  'profile.perkFreeSpins': 'Rodadas grátis por dia',
  'profile.perkDiscount': 'Bônus de depósito',
  'profile.freeSpinsLeft': 'Rodadas grátis restantes',
  'profile.claimDaily': 'Resgatar hoje',
  'profile.claimed': 'Resgatado hoje',
  'profile.noRewardYet': 'Sem recompensa disponível',
  'profile.rewardFromLevel': 'Giros grátis diários a partir do VIP {n}',
  'vip.title': 'Níveis VIP',
  'vip.level': 'Nível',
  'vip.threshold': 'Depositado',
  'vip.withdrawLimit': 'Saque diário',
  'vip.you': 'atual',
  'vip.basis': 'Seu nível VIP é calculado pelo total de depósitos válidos.',
  'vip.noteClaim': 'Os giros grátis diários precisam ser resgatados no seu perfil, uma vez por dia. Depois de resgatados, são seus.',
  'vip.noteDiscount': 'O bônus de depósito e o limite de saque diário vêm com o nível — não precisa resgatar.',
  'vip.noteMinWithdraw': 'Valor mínimo por saque: {v}.',
  'vip.noteMonotonic': 'O total depositado só aumenta, então seu nível nunca cai.',
  'vip.open': 'Ver níveis VIP',
  'err.NOTHING_TO_CLAIM': 'Seu nível ainda não tem recompensa diária',
  'err.ALREADY_CLAIMED': 'Você já resgatou hoje',
  'err.INSUFFICIENT_FUNDS': 'Saldo insuficiente',
  'err.BAD_REQUEST': 'Há algo inválido no que você enviou',

  'settings.title': 'Configurações',
  'settings.skin': 'Tema',
  'settings.mode': 'Aparência',
  'settings.language': 'Idioma',
  'settings.account': 'Conta',
  'settings.notLoggedIn': 'Você não está conectado.',
  'settings.playerId': 'ID do jogador',
  'settings.devices': 'Dispositivos conectados',
  'settings.loading': 'Carregando…',
  'settings.unknownDevice': 'Dispositivo desconhecido',
  'settings.current': 'Este aparelho',
  'settings.revokeOthers': 'Sair dos outros aparelhos',
  'settings.logout': 'Sair',

  'skin.laroluna': 'LaroLuna · Luar',
  'luna.title': 'Encontre seu próximo favorito.',
  'luna.note': 'Um toque de luar. Um mundo de diversão.',
  'skin.midnight': 'Meia-noite',
  'skin.sunset': 'Pôr do sol',
  'mode.system': 'Sistema',
  'mode.dark': 'Escuro',
  'mode.light': 'Claro',

  'time.justNow': 'Ativo agora',
  'time.minutesAgo_one': 'há {n} minuto',
  'time.minutesAgo_other': 'há {n} minutos',
  'time.hoursAgo_one': 'há {n} hora',
  'time.hoursAgo_other': 'há {n} horas',
  'time.daysAgo_one': 'há {n} dia',
  'time.daysAgo_other': 'há {n} dias',

  // ---- Loja ----
  'shop.title': 'Depositar',
  'shop.buy': 'Comprar',
  'shop.bought': 'Creditado',
  'shop.getCoins': 'Você recebe {v}',
  'shop.bonus': '+{v} de bônus',
  'shop.origPrice': 'de {v}',
  'shop.soldOut': 'Limite de hoje atingido',
  'shop.leftToday_one': 'resta {n} compra hoje',
  'shop.leftToday_other': 'restam {n} compras hoje',
  'shop.limitToday_one': 'Limite de {n} por dia',
  'shop.limitToday_other': 'Limite de {n} por dia',
  'shop.empty': 'Nada disponível no momento',
  'shop.devPay': 'Ambiente de desenvolvimento: a compra é creditada na hora, sem pagamento real.',
  'shop.tag.hot': 'Popular',
  'shop.tag.best': 'Melhor oferta',
  'shop.tag.daily': 'Diário',
  'shop.tag.first': 'Primeira compra',
  'shop.history': 'Histórico de compras',
  'shop.noHistory': 'Nenhuma compra ainda',
  'shop.st.created': 'Aguardando pagamento',
  'shop.st.paid': 'Creditando',
  'shop.st.credited': 'Creditado',
  'shop.st.cancelled': 'Cancelado',
  'shop.st.expired': 'Expirado',

  'err.PRODUCT_UNAVAILABLE': 'Esse item não está disponível agora',
  'err.PURCHASE_LIMIT': 'Você atingiu o limite de hoje para este item',
  'err.CREDIT_FAILED': 'O pagamento passou mas as moedas não chegaram — fale com o suporte',

  // ---- Saque / dados de recebimento ----
  'withdraw.title': 'Saque',
  'withdraw.action': 'Sacar',
  'withdraw.available': 'Saldo disponível',
  'withdraw.payoutTo': 'Dados de recebimento',
  'withdraw.noIdentity': 'Nenhum dado de recebimento',
  'withdraw.bindFirst': 'Cadastre o CPF do titular antes de sacar',
  'withdraw.cpf': 'CPF',
  'withdraw.cpfHint': '11 dígitos, ex.: {example}',
  'withdraw.holderName': 'Nome do titular',
  'withdraw.holderNameHint': 'Precisa ser igual ao nome do CPF — o banco confere',
  'withdraw.bind': 'Salvar dados',
  'withdraw.bound': 'Cadastrado',
  'withdraw.cannotUnbind': 'Você não pode alterar esses dados. Fale com o suporte para trocar.',
  'withdraw.oncePerAccount': 'Um CPF por conta, e cada CPF só pode ser usado em uma conta.',
  'withdraw.wagerBlocked': 'Rollover não concluído — faltam {v}',
  'withdraw.notOpenYet': 'O saque abre em breve. Já dá para cadastrar seus dados.',

  'err.BAD_CPF': 'CPF inválido — confira os números',
  'err.IDENTITY_TAKEN': 'Esse CPF já está em uso',
  'err.IDENTITY_ALREADY_BOUND': 'Esta conta já tem dados de recebimento',

  'withdraw.amount': 'Valor',
  'withdraw.amountHint': '{min} – {max}',
  'withdraw.submit': 'Solicitar saque',
  'withdraw.submitted': 'Solicitação enviada — aguardando análise',
  'withdraw.all': 'Máx.',
  'withdraw.dailyLimit': 'Limite de hoje',
  'withdraw.dailyLeft': 'restam {v}',
  'withdraw.vipTip': 'VIP {n} pode sacar {v} por dia — deposite para aumentar',
  'withdraw.history': 'Histórico',
  'withdraw.noHistory': 'Nenhum saque ainda',
  'withdraw.st.pending': 'Em análise',
  'withdraw.st.approved': 'Aprovado',
  'withdraw.st.rejected': 'Recusado',
  'withdraw.refunded': 'Valor devolvido ao saldo',
  // ---- Mensagens ----
  'mail.title': 'Mensagens',
  'mail.entry': 'Mensagens',
  'mail.empty': 'Nenhuma mensagem ainda',
  'mail.unknown.title': 'Nova mensagem',
  'mail.unknown.body': 'Você tem uma nova mensagem.',
  'mail.withdrawPaid.title': 'Saque pago',
  'mail.withdrawPaid.body': 'Seu saque de {amount} foi pago — você recebeu {net} (taxa {fee}).',
  'mail.withdrawFailed.title': 'Saque não realizado',
  'mail.withdrawFailed.body': 'Não foi possível pagar seu saque de {amount}. O valor total voltou para o seu saldo.',
  'mail.withdrawRejected.title': 'Saque recusado',
  'mail.withdrawRejected.body': 'Seu saque de {amount} não foi aprovado. O valor total voltou para o seu saldo.',
  'mail.attachment': 'Anexo',
  'mail.coins': 'Moedas {v}',
  'mail.wager': 'Apostas exigidas {v}',
  'mail.wagerNote': 'Depois de resgatar, é preciso apostar esse valor antes de sacar',
  'mail.claim': 'Resgatar',
  'mail.claimed': 'Resgatado',
  'mail.claimedOk': 'Você resgatou {v}',
  'mail.claimedOkWager': 'Você resgatou {v} — exigência de apostas +{w}',
  'err.NO_SUCH_MAIL': 'Essa mensagem não existe',
  'action.more': 'Carregar mais',

  'withdraw.fee': 'Taxa',
  'withdraw.feeFree': 'Sem taxa',
  'withdraw.net': 'Você recebe',
  'withdraw.feeFreeAt': 'Sem taxa a partir do VIP {n}',
  'withdraw.itemFee': 'Taxa {f} · recebido {v}',
  'withdraw.submittedFee': 'Solicitação enviada — você recebe {v} (taxa {f})',
  'withdraw.noQuotaLeft': 'Limite de hoje esgotado',

  'err.NO_PAYOUT_IDENTITY': 'Cadastre seus dados de recebimento primeiro',
  'err.WAGER_NOT_MET': 'Rollover não concluído',
  'err.WITHDRAW_TOO_SMALL': 'Abaixo do valor mínimo de saque',
  'err.WITHDRAW_OVER_LIMIT': 'Acima do limite de saque de hoje',
  'err.WITHDRAW_NOT_PENDING': 'Essa solicitação já foi processada',

  // ---------------------------------------------------------------- indicação
  'ref.needLogin': 'Entre para ver o seu link de indicação',
  'ref.myLink': 'Meu link de indicação',
  'ref.copy': 'Copiar',
  'ref.copied': 'Copiado',
  'ref.code': 'Código de convite: {v}',
  'ref.pending': 'Comissão a receber',
  'ref.claim': 'Resgatar',
  'ref.claimed': 'Resgatou {v}, +{n} giros grátis',
  'ref.claimedCash': 'Resgatou {v}',
  'ref.spins_one': '{n} giro grátis',
  'ref.spins_other': '{n} giros grátis',
  'ref.team': 'Minha equipe',
  'ref.level': 'Nível {n}',
  'ref.effN_one': '{n} válido',
  'ref.effN_other': '{n} válidos',
  'ref.tapForList': 'Toque em um nível para ver a lista',
  'ref.levelTitle': 'Indicados de nível {n}',
  'ref.total_one': '{n} pessoa',
  'ref.total_other': '{n} pessoas',
  'ref.noOne': 'Ainda não há ninguém neste nível',
  'ref.noName': 'Sem apelido',
  'ref.effective': 'Válido',
  'ref.notEffective': 'Ainda não',
  'ref.prev': 'Anterior',
  'ref.next': 'Próxima',
  'ref.chests': 'Baús',
  'ref.needN_one': '{n} válido',
  'ref.needN_other': '{n} válidos',
  'ref.leftN_one': 'faltam {n}',
  'ref.leftN_other': 'faltam {n}',
  'ref.open': 'Abrir',
  'ref.claimedOne': 'Aberto',
  'ref.chestGot': 'Você ganhou {v}, +{n} giros grátis',
  'ref.chestGotCash': 'Você ganhou {v}',
  'ref.rules': 'Como funciona',
  'ref.r1': 'Quem se cadastrar pelo seu link vira seu indicado de nível 1; os indicados dele são nível 2, e os deles, nível 3.',
  'ref.r2': 'Um indicado passa a ser válido quando tiver depositado {d} no total e apostado {b} no total.',
  'ref.r3': 'A comissão vale para até {n} níveis, nas taxas abaixo, calculada sobre o valor que o indicado pagou.',
  'ref.r4': 'A comissão não cai sozinha — resgate nesta página. Ao atingir uma meta de indicados válidos de nível 1 você libera um baú; cada baú abre uma vez só.',
  'ref.tLevel': 'Nível',
  'ref.tRate': 'Taxa',
  'ref.tSpins': 'Giros grátis',
  'ref.version': 'Versão das regras {v}',

  // ---------------------------------------------------------------- pagamento
  'pay.title': 'Concluir pagamento',
  'pay.amount': 'Valor a pagar',
  'pay.copy': 'Copiar código PIX',
  'pay.copied': 'Copiado',
  'pay.howto': 'Copie o código, abra o app do seu banco e escolha PIX «Copia e Cola» para pagar.',
  'pay.noCode': 'Este provedor não forneceu um código para copiar — use a página de pagamento abaixo.',
  'pay.openPage': 'Abrir página de pagamento',
  'pay.expiresIn': 'Expira em {v}',
  'pay.waiting': 'Assim que você pagar, esta página atualiza sozinha — não precisa sair.',
  'pay.crediting': 'Pagamento recebido, creditando…',
  'pay.done': 'Creditado',
  'pay.orderNo': 'Pedido',
  'pay.st.expired': 'Este código de pagamento expirou',
  'pay.st.cancelled': 'Este pedido foi cancelado',
  'pay.again': 'Fazer novo pedido',

  // ---------------------------------------------------------------- quadro interno
  'action.back': 'Voltar',
  'frame.blocked': 'Esta página não permite ser incorporada. Use a opção abaixo.',
  'frame.pay': 'Pagamento',
  'frame.game': 'Jogo',
  'frame.gameBlocked': 'O jogo não carregou. Tente novamente mais tarde.',
  'frame.exitGame': 'Voltar ao lobby',
  'pay.toastOk': 'Pagamento creditado, +{v} moedas',
};
